import { render, staticRenderFns } from "./OrderCreate.vue?vue&type=template&id=1f2fc968&scoped=true&"
import script from "./OrderCreate.vue?vue&type=script&lang=js&"
export * from "./OrderCreate.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreate.vue?vue&type=style&index=0&id=1f2fc968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2fc968",
  null
  
)

export default component.exports